import { useNavigate } from "react-router";
import { ArrowLeft, Eye } from "lucide-react";
import { usePreviewAs } from "@/lib/preview-as-context";

// Shown at the top of the partner portal when the viewer is an internal user
// previewing as a partner. Mirrors /components/portal/PreviewAsBanner.tsx —
// strictly read-only signal. Write actions still gate server-side, so the
// banner is purely an affordance.
export function PreviewAsBanner() {
  const { preview, returnTo, exit } = usePreviewAs();
  const navigate = useNavigate();
  if (!preview) return null;

  function handleExit() {
    const target = returnTo ?? "/admin/dashboard";
    // Clear preview state first so the next render doesn't keep the banner
    // up while navigating, and so the destination admin page renders without
    // X-Preview-As headers on its queries.
    exit();
    navigate(target);
  }

  return (
    <div className="border-b border-accent/30 bg-accent/10 text-accent">
      <div className="mx-auto flex h-9 max-w-[1100px] items-center justify-between gap-3 px-6 text-xs font-medium">
        <span className="flex items-center gap-1.5">
          <Eye className="h-3.5 w-3.5" />
          Previewing as {preview.partnerName} — read-only. Submissions are disabled.
        </span>
        <button
          type="button"
          onClick={handleExit}
          className="inline-flex items-center gap-1 underline-offset-2 hover:underline"
        >
          <ArrowLeft className="h-3 w-3" />
          Back to admin
        </button>
      </div>
    </div>
  );
}
